<template>
  <v-card>
    <div class="flex-grow-1 px-2">
      <div class="title-bar d-flex justify-space-between">
        <div>
          <div class="title">
            {{device.name}} ({{device.electronic_device_id}})
          </div>
        </div>
        <div class="actions">
          <ButtonActionEdit @click="$emit('edit')" />
          <ButtonActionDelete v-if="!isRegistered" @click="$emit('delete')" />
        </div>
      </div>
      <v-card-text>
        <v-row>
          <div class="user-card-label">
            ID blagajne:
          </div>
          <div class="user-card-value text-right">
            <span>{{ electronicDeviceId }}</span>
          </div>
        </v-row>
        <v-row>
          <div class="user-card-label">
            Registrirana:
          </div>
          <div class="user-card-value">
            <ActiveIcon :value="isRegistered" />
            <v-btn
              v-if="isRegistered"
              class="float-right"
              color="#0F998E"
              dark
              small
              @click="$emit('deregister')"
            >
              Prekliči
            </v-btn>
          </div>
        </v-row>
        <v-row class="mt-2" v-if="isRegistered">
          <div class="user-card-label">
            Aktivna:
          </div>
          <div class="user-card-value">
            <ActiveIcon :value="device.enabled" />
            <v-btn
              class="float-right"
              color="#0F998E"
              dark
              small
              @click="$emit('toggleActive')"
            >
              {{ device.enabled ? 'Deaktiviraj' : 'Aktiviraj' }}
            </v-btn>
          </div>
        </v-row>
        <!-- <v-row class="mt-2" v-if="isRegistered">
          <div class="user-card-label">
            Testni računi:
          </div>
          <div class="user-card-value">
            <ActiveIcon :value="isRegistered" />
            <v-btn
              v-if="isRegistered"
              class="float-right"
              color="#0F998E"
              dark
              small
              @click="$emit('deregister')"
            >
              Prekliči
            </v-btn>
          </div>
        </v-row> -->
        <v-row class="mt-2">
          <div class="user-card-label">
            FURS potrjevanje:
          </div>
          <div class="user-card-value">
            <ActiveIcon :value="device.fiscalization" />
            <!-- <v-btn
              class="float-right"
              color="#0F998E"
              dark
              small
              @click="$emit('toggleFiscalization')"
            >
              {{ device.fiscalization ? 'Izklop' : 'Vklop' }}
            </v-btn> -->
          </div>
        </v-row>
        <v-row class="mt-2">
          <div class="user-card-label">
          </div>
          <div class="user-card-value">
            <v-btn
              class="float-right"
              color="#0F998E"
              dark
              small
              @click="$emit('sourceFile')"
            >
              Izvorna datoteka
            </v-btn>
          </div>
        </v-row>
        <v-row class="mt-6">
          <div class="user-card-label">
            Zadnja sinhronizacija:
          </div>
          <div class="user-card-value">
            <span class="float-right">
              {{device.last_communication_time | utcToLocal | sloDateTime}}
            </span>
          </div>
        </v-row>
        <v-row class="mt-1">
          <div class="user-card-label">
            Platforma:
          </div>
          <div class="user-card-value">
            <span class="float-right">
              {{appPlatform}}
            </span>
          </div>
        </v-row>
        <v-row class="mt-1">
          <div class="user-card-label">
            Verzija:
          </div>
          <div class="user-card-value">
            <span class="float-right">
              {{appVersion}}
            </span>
          </div>
        </v-row>
        <v-row class="mt-1">
          <div class="user-card-label">
            Št. decimalnih mest:
          </div>
          <div class="user-card-value">
            <span class="float-right">
              {{decimalPlaces}}
            </span>
          </div>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import ButtonActionEdit from './ButtonActionEdit'
import ButtonActionDelete from './ButtonActionDelete'
import ActiveIcon from './ActiveIcon'

export default {
  components: {
    ButtonActionEdit,
    ButtonActionDelete,
    ActiveIcon
  },
  props: {
    device: {
      required: true,
      type: Object
    }
  },
  computed: {
    electronicDeviceId () {
      return this.device.id
    },
    isRegistered () {
      return this.device.activation_date !== null
    },
    appPlatform () {
      if (!this.device.app_platform) return 'Ni podatka'
      return this.device.app_platform === 'win' ? 'Windows' : 'Android'
    },
    appVersion () {
      if (!this.device.app_version) return '1.5.0 ali manj'
      return this.device.app_version
    },
    decimalPlaces () {
      if (!this.device.decimal_places) return '2'
      return this.device.decimal_places
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-card {
    padding: 20px;
  }
  .title-bar {
    padding: 10px;
    padding-bottom: 20px;
    box-shadow: 0 4px 3px -5px #455A64;

    .title {
      font-size: 22px;
      font-weight: bold;
      color: #607D8B;
    }
    .subtitle {
      color: #B0BEC5;
      font-size: 12px;
    }
    .actions {
      max-width: 90px;
      margin-left: 15px;
    }
  }
  .v-card__text {
    .col {
      padding: 6px 12px;
    }
    .row {
      flex-wrap: nowrap;
    }
    .user-card-label {
      min-width: 150px;
      color: #BDBDBD;
    }
    .user-card-value {
      min-width: 160px;
      color: #607D8B;
      font-weight: bold;
      flex: 1;
    }
  }

  .hr-breakpoint-mobile {
    .v_card__text .row {
      flex-wrap: wrap !important;
    }
  }
</style>
